// Inside my /resources/assets/js/lang.js
import lang from 'lang.js';
import messages from './messages';
import {usePage} from "@inertiajs/inertia-vue3";
import deepExtend from 'deep-extend';

const l = new lang({
    messages,
    locale: document.documentElement.getAttribute('data-w3r-locale'),
    fallback: document.documentElement.getAttribute('data-w3r-locale-fallback')
});

let translationsMerged = false;
l._getMessage = function (key, locale) {
    if(!translationsMerged) {
        this.messages = deepExtend(this.messages, usePage().props.value.translations);
        translationsMerged = true;
    }

    locale = locale || this.getLocale();

    key = this._parseKey(key, locale);

    // Ensure message source exists.
    if (this.messages[key.source] === undefined && this.messages[key.sourceFallback] === undefined) {
        return null;
    }

    // Get message from default locale.
    var message = this.messages[key.source];
    var entries = key.entries.slice();
    var subKey = entries.join('.');
    message = message !== undefined ? this._getValueInKey(message, subKey) : undefined;


    // Get message from fallback locale.
    if ((typeof message !== 'string' && !Array.isArray(message)) && this.messages[key.sourceFallback]) {
        message = this.messages[key.sourceFallback];
        entries = key.entries.slice();
        subKey = '';
        while (entries.length && message !== undefined) {
            var subKey = !subKey ? entries.shift() : subKey.concat('.', entries.shift());
            if (message[subKey]) {
                message = message[subKey]
                subKey = '';
            }
        }
    }

    if (typeof message !== 'string' && !Array.isArray(message)) {
        return null;
    }

    return message;
}

export default function (prefix) {
    return (key, replacements) => {
        if(prefix === undefined) {
            return l.get(key, replacements);
        }

        return l.get(prefix + '.' + key, replacements);
    }
};
